module.exports = __webpack_public_path__ + "img/banner.622bac32.png";